import { z } from "zod"

const customTextFieldSpecSchema = z.object({
    type: z.literal("text"),
    id: z.string(),
    label: z.string().min(1),
})

const customYesNoFieldSpecSchema = z.object({
    type: z.literal("yes-no"),
    id: z.string(),
    label: z.string().min(1),
})

const customMultipleChoiceFieldSpecSchema = z.object({
    type: z.literal("multiple-choice"),
    id: z.string(),
    label: z.string().min(1),
    options: z.array(z.string().min(1)).min(1),
})

export const customFieldSpecSchema = z.discriminatedUnion("type", [
    customTextFieldSpecSchema,
    customYesNoFieldSpecSchema,
    customMultipleChoiceFieldSpecSchema,
])

export type CustomFieldType = "text" | "yes-no" | "multiple-choice"
export type CustomFieldSpec<T extends CustomFieldType = CustomFieldType> = Extract<
    z.infer<typeof customFieldSpecSchema>,
    { type: T }
>

export const missionCustomFieldDefinitionRecordSchema = z.object({
    id: z.uuid(),
    org_id: z.string(),
    form: z.array(customFieldSpecSchema),
    created_at: z.string(),
    updated_at: z.string(),
})

export const missionCustomFieldDefinitionSchema =
    missionCustomFieldDefinitionRecordSchema.transform((r) => ({
        id: r.id,
        orgId: r.org_id,
        form: r.form,
        createdAt: r.created_at,
        updatedAt: r.updated_at,
    }))

export const updatableMissionCustomFieldDefinitionSchema =
    missionCustomFieldDefinitionRecordSchema.pick({
        form: true,
    })

export type MissionCustomFieldDefinitionRecord = z.infer<
    typeof missionCustomFieldDefinitionRecordSchema
>
export type MissionCustomFieldDefinition = z.infer<typeof missionCustomFieldDefinitionSchema>
export type UpdatableMissionCustomFieldDefinition = z.infer<
    typeof updatableMissionCustomFieldDefinitionSchema
>
